import styled from 'styled-components';

export const HeaderStyled = styled(`header`)`
	gap: 27px;
	display: flex;
	margin-bottom: 26px;
`;

export const LogoMStyled = styled.img`
	width: 87px;
	height: 87px;
	border: 0.725px solid #d9d9d9;
	border-radius: 14px;
`;

export const NameStyled = styled(`h3`)`
	margin: 0;
	font-weight: 600;
	font-size: 20px;
	line-height: 28px;
`;

export const NameContainerStyled = styled.div`
	gap: 4px;
	display: flex;
	flex-direction: column;
	margin-bottom: 5px;
`;

export const DeveloperStyled = styled(`p`)`
	margin: 0;
	margin-bottom: 8px;
	color: #262626;
	font-weight: 300;
	font-size: 14px;
	line-height: 22px;
`;

export const HeaderDescriptionStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
`;
